export default __webpack_public_path__ + "static/media/7-100.61ea9d1c.jpg";